<template>
  <div id="container">
    <div
      id="cookie-btn"
      v-show="cookie_page === 'cookie-btn'"
    >
      <el-tooltip content="Cookie Settings" placement="right">
        <img
          style="width: 48px; height: 48px;"
          src="../assets/icons/svg/cookie_btn.svg"
          alt=""
          @click="clickBtn"
        />
      </el-tooltip>
    </div>
    <div
      id="cookie-widget"
      v-show="cookie_page === 'cookie-widget'"
    >
      <div id="widget-header">
        <strong>Cookie settings</strong>
        <div id="widget-close">
          <img
            src="../assets/icons/svg/close.svg"
            alt=""
            @click="closeCookieWidget"
          />
        </div>
      </div>
      <div id="widget-body">
        <div class="widget-body_inner">
          <div class="widget-body_inner__list">
            <strong class="widget-body_inner__state">Your current state</strong>
            <div>
              <div class="widget-body_inner__item">
                <div class="widget-body_inner__item__icon">
                  <img src="../assets/icons/svg/lock.svg" alt="" />
                </div>
                Essential website cookies
              </div>
              <div class="widget-body_inner__item">
                <div class="widget-body_inner__item__icon">
                  <img v-if="consent_body.functional" src="../assets/icons/svg/correction.svg" alt="" />
                  <img v-else src="../assets/icons/svg/close.svg" alt="" />
                </div>
                Performance and functionality cookies
              </div>
              <div class="widget-body_inner__item">
                <div class="widget-body_inner__item__icon">
                  <img v-if="consent_body.performance" src="../assets/icons/svg/correction.svg" alt="" />
                  <img v-else src="../assets/icons/svg/close.svg" alt="" />
                </div>
                Analytics and customisation cookies
              </div>
              <div class="widget-body_inner__item">
                <div class="widget-body_inner__item__icon">
                  <img v-if="consent_body.target" src="../assets/icons/svg/correction.svg" alt="" />
                  <img v-else src="../assets/icons/svg/close.svg" alt="" />
                </div>
                Advertising cookies
              </div>
            </div>
          </div>
          <div>
            <div>
              <div class="widget-body_inner__details" @click="widget_details = !widget_details">
                <div>
                  <strong v-if="widget_details">Hide details</strong>
                  <strong v-else>Show details</strong>
                </div>
                <div style="margin-left: 15px;">
                  <img
                    :style="{transform: widget_details ? '' : 'rotate(180deg)'}"
                    src="../assets/icons/svg/collapse_up.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div v-if="widget_details" id="widget-body_inner__box">
              <div id="widget-body_inner__box__inner">
                <div id="widget-body_inner__box__date">
                  <strong>Consent date:</strong>
                  <div class="detail-font">{{getShowDate()}}</div>
                </div>
                <div id="widget-body_inner__box__id">
                  <strong>Your consent ID:</strong>
                  <div class="detail-font">{{consent_body.stamp}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="widget-footer">
        <button
          id="widget-button_withdraw"
          :disabled="disable_withdraw_button"
          :style="{cursor: disable_withdraw_button ? 'not-allowed' : 'pointer'}"
          @click="setConsent('none')"
        >
          Withdraw your consent
        </button>
        <button
          id="widget-button_change"
          @click="showCookieDetail"
        >
          Change your consent
        </button>
      </div>
    </div>
    <div
      id="cookie-detail"
      v-show="cookie_page === 'cookie-detail'"
    >
      <div id="cookie-detail-wrapper">
        <div id="cookie-detail-header">
          <div id="cookie-detail-header__wrapper">
            <img id="cookie-detail-logo" src="../assets/icons/img/logo.png" alt="" />
          </div>
        </div>
        <div id="cookie-detail-nav">
          <div class="cookie-detail-nav_item">
            <a
              class="cookie-detail-nav_item__link"
              :class="cookie_detail_active_page === 'consent' ? 'active' : ''"
              @click="cookie_detail_active_page = 'consent'"
            >
              Consent
            </a>
          </div>
          <div class="cookie-detail-nav_item">
            <a
              class="cookie-detail-nav_item__link"
              :class="cookie_detail_active_page === 'detail' ? 'active' : ''"
              @click="cookie_detail_active_page = 'detail'"
            >
              Details
            </a>
          </div>
<!--          <div class="cookie-detail-nav_item">-->
<!--            <a-->
<!--              class="cookie-detail-nav_item__link"-->
<!--              :class="cookie_detail_active_page === 'about' ? 'active' : ''"-->
<!--              @click="cookie_detail_active_page = 'about'"-->
<!--            >-->
<!--              About-->
<!--            </a>-->
<!--          </div>-->
        </div>
        <div id="cookie-detail-body">
          <div class="cookie-detail-body-container" v-show="cookie_detail_active_page === 'consent'">
            <div class="cookie-detail-body_content" style="max-height: 18.6em !important;">
              <div>
                <div><strong>This website uses cookies</strong></div>
                This website uses cookies
                We and/or our partners use cookies and similar technologies to improve this website,
                to analyze traffic and user behaviour, and for personalizing content and ads on this and other websites.
                More information about how this website uses cookies is available in our
                <a target="_blank" href="https://spinxgames-policy.com/lotsa-slots/view#spinx-games-cookie-notice">Cookie Notice</a>
                and
                <a target="_blank" href="https://spinxgames-policy.com/lotsa-slots/view#lotsa-slots-privacy-policy">Privacy Policy</a>.
                Please note that some of the cookies are essential for parts of the website to operate.
                See the Details tab for more information.
                You can manage your preferences at any time by clicking the "Cookie Settings" button at the bottom of our website.
              </div>
            </div>
            <div id="cookie-detail-body_button">
              <div class="cookie-detail-body_button__item">
                <strong>Essential website cookies</strong>
                <el-switch
                  inactive-color="#000"
                  active-color="#5d0749"
                  v-model="consent_body.necessary"
                  disabled
                />
              </div>
              <div class="cookie-detail-body_button__item">
                <strong>Performance and functionality cookies</strong>
                <el-switch
                  inactive-color="#000"
                  active-color="#5d0749"
                  v-model="consent_body.functional"
                />
              </div>
              <div class="cookie-detail-body_button__item">
                <strong>Analytics and customisation cookies</strong>
                <el-switch
                  inactive-color="#000"
                  active-color="#5d0749"
                  v-model="consent_body.performance"
                />
              </div>
              <div class="cookie-detail-body_button__item">
                <strong>Advertising cookies</strong>
                <el-switch
                  inactive-color="#000"
                  active-color="#5d0749"
                  v-model="consent_body.target"
                />
              </div>
            </div>
          </div>
          <div class="cookie-detail-body-container" v-show="cookie_detail_active_page === 'detail'">
            <div class="cookie-detail-body_content">
              <div class="cookie-detail-body_content__summary">
                Some cookies are needed to make our websites work and can't be turned off.
                But we need your consent to use others that are not essential.
                You can make your choices below and update them at any time using the "Cookie Settings" link.
                To find out more, visit our
                <a target="_blank" href="https://spinxgames-policy.com/lotsa-slots/view#spinx-games-cookie-notice">Cookie Notice</a>.
              </div>
              <div
                class="cookie-detail-body_content__item"
                v-for="[cookie_type, cookie_body] in Object.entries(cookie_detail)"
              >
                <div class="cookie-detail-body_content__item__header">
                  <strong class="text-title" @click="cookie_detail_description[cookie_type].collapse = !cookie_detail_description[cookie_type].collapse">
                    <img
                      class="title-img"
                      :style="{transform: cookie_detail_description[cookie_type].collapse ? 'rotate(180deg)' : ''}"
                      src="../assets/icons/svg/collapse_up_black.svg"
                      alt=""
                    />
                    <span style="line-height: 20px">{{cookie_detail_description[cookie_type].title}}</span>
                    <div class="title-number">
                      <div style="margin: 4px;">{{ Object.values(cookie_body).flat().length }}</div>
                    </div>
                  </strong>
                  <div>
                    <el-switch
                      inactive-color="#000"
                      active-color="#5d0749"
                      v-model="consent_body[cookie_type]"
                      :disabled="cookie_type === 'necessary'"
                    />
                  </div>
                </div>
                <div class="cookie-detail-body_content__item__content">
                  {{cookie_detail_description[cookie_type].description}}
                  <div v-show="!cookie_detail_description[cookie_type].collapse && Object.keys(cookie_body).length">
                    <div
                      v-for="[provider, cookies] of Object.entries(cookie_body)"
                      class="cookie-detail-body_content__item__content__inner"
                    >
                      <el-collapse>
                        <el-collapse-item>
                          <template slot="title">
                            <div style="display: flex; flex-direction: column;">
                              <div style="display: flex">
                                <strong style="font-size: 16px">{{ provider }}</strong>
                                <div class="title-number" style="margin: 4px;">{{ cookies.length }}</div>
                              </div>

                              <strong v-if="website_link[provider]" style="font-size: 14px;">
                                <a target="_blank" :href="website_link[provider]">Learn more about this provider</a>
                              </strong>

                            </div>
                          </template>
                          <div
                              v-for="item of cookies"
                              :key="item.cookie_name"
                              class="cookie-detail-body_content__item__content__inner__item"
                          >
                            <div style="margin-bottom: 20px;">
                              <div><strong>{{ item.cookie_name }}</strong></div>
                              <div style="color: #000">{{ item.description }}</div>
                            </div>

                            <div class="cookie-detail-item_info">
                              <div style="flex: 0 0 50%">
                                <strong>Maximum Storage Duration:</strong>
                                {{ item.maximum_duration }}
                              </div>
                              <div style="flex: 0 0 50%">
                                <strong>Type:</strong>
                                {{ item.type || 'HTTP Cookie' }}
                              </div>
                            </div>
                          </div>
                        </el-collapse-item>
                      </el-collapse>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="cookie-detail-footer">
          <div id="cookie-detail-footer-container">
            <button id="cookie-detail-button__reject" @click="setConsent('none')">
              Reject all
            </button>
            <button id="cookie-detail-button__reject" @click="setConsent('selection')">
              Allow selection
            </button>
            <button id="cookie-detail-button__reject" @click="setConsent('all')">
              Allow all
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="cookie_page === 'cookie-detail'"
      @wheel.stop.prevent
      @click.stop.prevent
      @scroll.stop.prevent
      class="overlay"
    >
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import axios from "axios";

export default {
  data() {
    return {
      cookie_page: 'cookie-btn',
      localstorage_name: 'cookie-consent',
      consent_body: {
        necessary: true,
        performance: false,
        functional: false,
        target: false,
      },
      cookie_detail_collapse: {
        necessary: true,
        performance: true,
        functional: true,
        target: true,
      },
      widget_details: false,
      cookie_detail_active_page: 'consent',
      website_link: {
        Google: 'https://business.safety.google/privacy/',
      },
      cookie_detail_description: {
        necessary: {
          collapse: true,
          title: 'Essential website cookies',
          description: 'These cookies are strictly necessary to provide you with services available through our websites and to use some of its features, such as access to secure areas.',
        },
        performance: {
          collapse: true,
          title: 'Performance and functionality cookies',
          description: 'These cookies are used to enhance the performance and functionality of our websites but are non-essential to their use. However, without these cookies, certain functionality may become unavailable.',
        },
        functional: {
          collapse: true,
          title: "Analytics and customisation cookies",
          description: "These cookies help us understand how you interact with our website, allowing us to improve performance and tailor your experience. They enable the site to remember your preferences (such as language or region) and provide enhanced features.",
        },
        target: {
          collapse: true,
          title: 'Advertising cookies',
          description: 'These cookies are used to make advertising messages more relevant to you. They perform functions like preventing the same ad from continuously reappearing, ensuring that ads are properly displayed for advertisers, and in some cases selecting advertisements that are based on your interests.',
        },
      },
      cookie_detail: {
        necessary: {
          Google: [
            {
              cookie_name: 'SID',
              type: 'HTML Local Storage',
              description: 'Contains digitally signed and encrypted records of a user\'s Google account ID and last sign-in time. Used for security, such as preventing credential theft and abuse of Google services.',
              maximum_duration: '1 year',
            }
          ]
        },
        performance: {},
        functional: {},
        target: {
          Google: [
            {
              cookie_name: 'AEC',
              type: 'HTTP Cookie',
              description: 'Appears to be related to user authentication and security. It may be used to authenticate users and prevent fraudulent use of user data.',
              maximum_duration: '6 months',
            },
            {
              cookie_name: 'APISID',
              type: 'HTML Local Storage',
              description: 'Stores a unique session identifier. Used by Google to authenticate users and prevent fraudulent use of login credentials and protect user data from unauthorized access.',
              maximum_duration: '1 year',
            },
            {
              cookie_name: 'HSID',
              type: 'HTTP Cookie',
              description: 'Contains the digitally signed and encrypted records of a user\'s sign-in time and Google account ID. Used for security, such as preventing credential theft and abuse of Google services.',
              maximum_duration: '1 year',
            },
            {
              cookie_name: 'NID',
              type: 'HTTP Cookie',
              description: 'Registers a unique ID that identifies a returning user\'s device. The ID is used for targeted ads.',
              maximum_duration: '6 months',
            },
            {
              cookie_name: 'SAPISID',
              type: 'HTML Local Storage',
              description: 'Used to identify the user\'s Google account and authenticate the user when using Google services. Similar to APISID but used for Google hosted services.',
              maximum_duration: '1 year',
            },
            {
              cookie_name: 'SIDCC',
              type: 'HTML Local Storage',
              description: 'Improves security by protecting a user\'s account login details when they access Google services, such as YouTube, from their browser. It is used to prevent cross-site request forgery (CSRF) attacks.',
              maximum_duration: '1 year',
            },
            {
              cookie_name: 'SSID',
              type: 'HTTP Cookie',
              description: 'Stores information about how the user uses the website and any advertising that the user may have seen before visiting the site.',
              maximum_duration: '1 year',
            },
            {
              cookie_name: 'Secure-1PAPISID',
              type: 'HTML Local Storage',
              description: 'A secure version of APISID, transmitted over HTTPS. Stores a unique session identifier. Used by Google to authenticate users and prevent fraudulent use of login credentials and protect user data from unauthorized access.',
              maximum_duration: '1 year',
            },
            {
              cookie_name: 'Secure-1PSID',
              type: 'HTTP Cookie',
              description: 'A secure version of SID, transmitted over HTTPS. Contains digitally signed and encrypted records of a user\'s Google account ID and last sign-in time. Used for security, such as preventing credential theft and abuse of Google services.',
              maximum_duration: '1 year',
            },
            {
              cookie_name: 'Secure-1PSIDCC',
              type: 'HTTP Cookie',
              description: 'A secure version of SIDCC, transmitted over HTTPS. Improves security by protecting a user\'s account login details when they access Google services, such as YouTube, from their browser. It is used to prevent cross-site request forgery (CSRF) attacks.',
              maximum_duration: '1 year',
            },
            {
              cookie_name: 'Secure-1PSIDTS',
              type: 'HTTP Cookie',
              description: 'Contains the timestamp of the last time the user signed in. This helps Google identify the user and provide personalized services.',
              maximum_duration: '1 year',
            },
            {
              cookie_name: 'Secure-3PAPISID',
              type: 'HTML Local Storage',
              description: 'A secure third-party version of APISID, transmitted over HTTPS. Stores a unique session identifier. Used by Google to authenticate users and prevent fraudulent use of login credentials and protect user data from unauthorized access.',
              maximum_duration: '1 year',
            },
            {
              cookie_name: 'Secure-3PSID',
              type: 'HTTP Cookie',
              description: 'A secure third-party version of SID, transmitted over HTTPS. Contains digitally signed and encrypted records of a user\'s Google account ID and last sign-in time. Used for security, such as preventing credential theft and abuse of Google services.',
              maximum_duration: '1 year',
            },
            {
              cookie_name: 'Secure-3PSIDCC',
              type: 'HTTP Cookie',
              description: 'A secure third-party version of SIDCC, transmitted over HTTPS. Improves security by protecting a user\'s account login details when they access Google services, such as YouTube, from their browser. It is used to prevent cross-site request forgery (CSRF) attacks.',
              maximum_duration: '1 year',
            },
            {
              cookie_name: 'Secure-3PSIDTS',
              type: 'HTTP Cookie',
              description: 'A secure third-party cookie that contains the timestamp of the last time the user signed in. This helps Google identify the user and provide personalized services.',
              maximum_duration: '1 year',
            },
            {
              cookie_name: '_tea_utm_cache_100000007',
              type: 'HTML Local Storage',
              description: 'A cookie used by Tealeaf, a customer experience analytics platform, to cache UTM parameters (campaign tracking information) for attribution purposes. It helps track the source of website traffic and conversions.',
              maximum_duration: '7 days',
            },
            {
              cookie_name: 'DSID',
              type: 'HTTP Cookie',
              description: 'Used by Google to remember a user\'s settings and preferences, such as their preferred language or the number of search results they want to see per page. It is also used to personalize the user\'s experience on Google websites and services.',
              maximum_duration: '7 days',
            },
            {
              cookie_name: 'IDE',
              type: 'HTTP Cookie',
              description: 'Used by Google DoubleClick to register and report the website user\'s actions after viewing or clicking one of the advertiser\'s ads with the purpose of measuring the efficacy of an ad and to present targeted ads to the user.',
              maximum_duration: '400 days',
            },
            {
              cookie_name: 'SEARCH_SAMESITE',
              type: 'HTML Local Storage',
              description: 'This cookie helps Google provide a more secure and reliable search experience. It is used to prevent cross-site request forgery (CSRF) attacks, ensuring that only legitimate requests are processed.',
              maximum_duration: '6 months',
            },
            {
              cookie_name: 'gcl_au',
              type: 'HTML Cookie',
              description: 'Used by Google AdSense for experimenting with advertisement efficiency across websites using their services.',
              maximum_duration: '3 months',
            },
          ],
        }
  },
    }
  },
  computed: {
    disable_withdraw_button() {
      const { necessary, performance, functional, target } = this.consent_body || {}
      return necessary && !performance && !functional && !target
    }
  },
  watch: {
    cookie_page(val) {
      if (val === 'cookie-detail') {
        document.body.style['overflow-y'] = 'hidden'
      } else {
        document.body.style['overflow-y'] = 'auto'
      }
    }
  },
  methods: {
    loadScripts() {
      const src = 'https://www.googletagmanager.com/gtag/js?id=AW-753868933'
      const head = document.head || document.getElementsByTagName('head')[0]
      const hasElem = head.querySelector(`script[src="${src}"]`)
      if (hasElem) {
        return
      }
      const elem = document.createElement('script')
      elem.src = src
      elem.async = true
      document.head.appendChild(elem)

      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-753868933');
      gtag('event', 'conversion', {'send_to': 'AW-753868933/e3xPCMuI76cYEIXBvOcC'});
    },
    generateRandomId(length) {
      const array = new Uint8Array(length);
      window.crypto.getRandomValues(array);
      return btoa(String.fromCharCode.apply(null, array));
    },
    saveUserConsent() {
      const {hostname, origin} = document.location
      const {userAgent, platform, language, cookieEnabled, geolocation} = navigator
      const body = Object.assign(
        {},
        this.consent_body,
        {
          hostname,
          origin,
          userAgent,
          platform,
          language,
          cookieEnabled,
          geolocation: JSON.stringify(geolocation || {}),
          utc: moment(this.consent_body.utc).format(),
        }
      )
      axios.post('https://us-central1-bolegame.cloudfunctions.net/legal_cookie_management', body)
    },
    setCookies(type) {
      const { functional, performance, target } = this.consent_body
      if (functional && performance && target) {
        this.loadScripts()
      }
      if (!target) {
        ['_gcl_au', '_ga', '_ga_5Y4H67BB2N', '_tea_utm_cache_10000007'].forEach(i => {
          document.cookie = i + '=0;expires=' + new Date(0).toUTCString()
        })
      }
      if (type === 'save') {
        this.saveUserConsent()
      }
    },
    setConsent(type) {
      if (type === 'all') {
        this.consent_body = {
          stamp: this.generateRandomId(64),
          necessary: true,
          performance: true,
          functional: true,
          target: true,
          utc: moment.utc(),
        }
      } else if (type === 'none') {
        this.consent_body = {
          stamp: this.generateRandomId(64),
          necessary: true,
          performance: false,
          functional: false,
          target: false,
          utc: moment.utc(),
        }
      }
      localStorage.setItem(this.localstorage_name, JSON.stringify(this.consent_body))
      // const {functional, target, performance} = this.consent_body
      // if (!functional || !target || !performance) {
      //   location.reload()
      // }
      this.setCookies('save')
      this.closeCookieWidget()
    },
    clickBtn() {
      this.cookie_page = 'cookie-widget'
    },
    showCookieDetail() {
      this.cookie_page = 'cookie-detail'
    },
    closeCookieWidget() {
      this.widget_details = false
      this.cookie_detail_active_page = 'consent'
      this.getConsentInfo()
      this.cookie_page = 'cookie-btn'
      this.cookie_detail_collapse = {
        necessary: true,
        performance: true,
        functional: true,
        target: true,
      }
    },
    getShowDate() {
      return moment(this.consent_body.utc).format()
    },
    getConsentInfo() {
      const consent_info = localStorage.getItem(this.localstorage_name)
      if (!consent_info) {
        this.setConsent('none')
        this.cookie_page = 'cookie-detail'
        return
      }
      this.consent_body = JSON.parse(consent_info)
    },
  },
  mounted() {
    this.getConsentInfo()
    setTimeout(() => {
      this.setCookies()
    }, 100)
  }
}
</script>

<style scoped lang="less">

/deep/ .el-switch__core {
  height: 28px !important;
  width: 52px !important;
  border-radius: 18px !important;
}

/deep/ .el-switch__core:after {
  width: 24px !important;
  height: 24px !important;
}

/deep/ .el-switch.is-checked .el-switch__core::after {
  margin-left: -25px !important;
}

#container {
  position: relative;
  z-index: 1001;
  max-height: 100%;
  overflow-y: auto;

  strong {
    font-weight: 900;
  }

  .overlay {
    background-color: #000;
    height: 100%;
    width: 100%;
    left: 0;
    margin: 0;
    opacity: 0.5;
    overflow: hidden;
    padding: 0;
    pointer-events: auto;
    position: fixed;
    top: 0;
    transition: opacity .5s ease;
    z-index: 1000;
  }

  #cookie-btn {
    width: 48px;
    height: 48px;
    cursor: pointer;
    overflow: hidden;
    z-index: 9999;
    border-radius: 4px;
    position: fixed;
    left: 0;
    bottom: 10px;
  }

  #cookie-widget {
    position: fixed;
    left: 0;
    bottom: 10px;
    max-width: 500px;
    display: flex;
    flex-direction: column;
    background: white;
    border-radius: 8px;
    transition: opacity .5s;

    #widget-header {
      padding: 3px 12px 3px 24px;
      align-items: center;
      border-bottom: 1px solid #D6D6D6;
      display: flex;
      justify-content: space-between;
      height: 48px;

      #widget-close {
        align-items: center;
        cursor: pointer;
        display: flex;
        justify-content: center;
        width: 48px;
      }
    }

    #widget-body {
      display: flex;
      overflow: hidden;
      padding: 6px;
      position: relative;
      font-size: 15px;

      .widget-body_inner {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        overflow-x: hidden;
        padding: 18px 18px 10px;
        align-items: flex-start;

        .widget-body_inner__list {
          margin-bottom: 28px;
          text-align: left;

          .widget-body_inner__state {
            display: block;
            margin-bottom: 8px;
            line-height: 1.5;
          }

          .widget-body_inner__item {
            letter-spacing: .3px;
            margin-bottom: 4px;
            line-height: 1.5;
            font-weight: 600;
            display: flex;

            .widget-body_inner__item__icon {
              width: 18px;
              margin-right: 10px;
              display: flex;
              align-items: center;
              justify-content: flex-start;
            }
          }
        }

        .widget-body_inner__details {
          align-items: center;
          color: #1032CF;
          cursor: pointer;
          display: flex;
          font-weight: 600;
          margin-bottom: 12px;
        }

        #widget-body_inner__box {
          width: 100%;
          background-color: #F2F2F2;
          border-radius: 8px;
          letter-spacing: .5px;
          display: flex;
          flex-wrap: wrap;

          #widget-body_inner__box__inner {
            padding: 16px;
            text-align: left;
            font-size: 14px;

            #widget-body_inner__box__date {
              margin-bottom: 16px;
            }

            #widget-body_inner__box__id {
              word-break: break-all;
            }

            .detail-font {
              font-size: 12px;
              font-weight: 600;
            }
          }
        }
      }
    }

    #widget-footer {
      border-top: 1px solid #D6D6D6;
      margin-top: auto;
      padding: 16px 24px;
      display: flex;

      button {
        border: 2px solid;
        border-radius: 4px;
        cursor: pointer;
        font-weight: 600;
        line-height: 1.2;
        margin-bottom: 8px;
        min-height: 48px;
        padding: 12px 16px;
        position: relative;
        text-align: center;
        transition: color .2s;
        width: 100%;
        font-size: 16px;
      }

      #widget-button_withdraw {
        opacity: .4;
        border-color: #141414;
        margin-right: 8px;
        //width: auto;
      }

      #widget-button_change {
        background-color: #1032CF;
        border-color: #1032CF;
        color: #FFFFFF;
        //width: auto;
      }
    }
  }

  #cookie-detail {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 32px 68px rgba(0, 0, 0, .3);
    box-sizing: border-box;
    color: #000000;
    font-family: sans-serif;
    font-size: 15px;
    height: auto;
    left: 50%;
    letter-spacing: .1px;
    line-height: 24px;
    max-height: calc(100% - 16px);
    position: fixed;
    text-align: initial;
    top: 50%;
    transform: translate(-50%, -50%);
    transition: opacity .5s ease;
    width: 94%;
    max-width: 900px;
    overflow: auto;
    z-index: 1001;

    #cookie-detail-wrapper {
      overflow: hidden;
      #cookie-detail-header {
        align-items: center;
        border-bottom: 1px solid #d6d6d6;
        display: flex;
        padding: 10px 20px;

        #cookie-detail-header__wrapper {
          align-items: center;
          display: flex;
          flex: 1;
          justify-content: space-between;

          #cookie-detail-logo {
            width: 120px;
          }
        }

        #cookie-detail-close {
          display: flex;
          align-items: center;
          cursor: pointer;
        }
      }

      #cookie-detail-nav {
        border-bottom: 1px solid #d6d6d6;
        position: relative;
        width: 100%;
        display: flex;
        justify-content: center;
        height: 60px;

        .cookie-detail-nav_item {
          flex: 1 1 0%;
          margin: 0 auto;
          display: flex;
          align-items: center;
          justify-content: center;

          .active {
            border-bottom: 3px solid #5d0749;
          }

          .cookie-detail-nav_item__link{
            color: #000000;
            display: block;
            font-weight: 600;
            outline-offset: -5px;
            padding: 1em;
            text-align: center;
            text-decoration: none;
            white-space: nowrap;
            width: 100%;
            cursor: pointer;
          }
        }
      }

      #cookie-detail-body {
        display: flex;
        flex-direction: column;
        height: auto;
        min-height: 60px;
        overflow: auto;
        width: 100%;

        .cookie-detail-body-container {
          //display: flex;
          //flex-direction: column;
          //justify-content: space-between;
          position: relative;
          overflow-y: auto;
          max-height: 330px;

          .cookie-detail-body_content {
            overflow-y: auto;
            overflow-x: hidden;
            padding: 0 25px;
            margin: 20px 0;

            .cookie-detail-body_content__summary {
              margin-bottom: 20px;
              padding-bottom: 30px;
              margin-top: 10px;
              border-bottom: 1px solid #d6d6d6;
            }

            strong {
              height: 32px;
              line-height: 32px;
            }

            .cookie-detail-body_content__item:last-of-type {
              border-bottom: none !important;
            }

            .cookie-detail-body_content__item {
              display: flex;
              flex-direction: column;
              margin-bottom: 20px;
              padding-bottom: 30px;
              border-bottom: 1px solid #d6d6d6;

              .cookie-detail-body_content__item__header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 10px;

                .text-title {
                  display: flex;
                  cursor: pointer;
                  align-items: center;
                  height: auto;

                  .title-img {
                    width: 16px;
                    margin-right: 10px;
                  }

                  .title-number {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-color: #eeeeee;
                    border-radius: 50%;
                    width: 16px;
                    height: 16px;
                    margin-left: 10px;
                    font-size: 12px;
                    padding: 4px;
                  }
                }
              }

              .cookie-detail-body_content__item__content {
                font-size: 14px;
                padding-left: 10px;

                .cookie-detail-body_content__item__content__inner {
                  border: 1px solid #d6d6d6;
                  border-radius: 7px;
                  padding: 20px;
                  margin-top: 20px;

                  /deep/ .el-collapse-item__header {
                    margin-bottom: 20px;
                    .el-icon-arrow-right:before {
                      content: '\e6e0';
                    }
                  }

                  .title-number {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-color: #eeeeee;
                    border-radius: 50%;
                    width: 16px;
                    height: 16px;
                    margin-left: 10px;
                    font-size: 12px;
                    padding: 4px;
                  }

                  a {
                    color: #1515ee;
                    font-size: 14px;
                  }

                  /deep/ .el-collapse {
                    border: none;
                    .el-collapse-item__header {
                      border-bottom: none;
                    }
                    .el-collapse-item__wrap {
                      border-bottom: none;
                    }
                    .el-collapse-item__content {
                      padding-bottom: 0;
                    }
                  }

                  .cookie-detail-body_content__item__content__inner__item {
                    background-color: #eeeeee;
                    border: 1px solid #eeeeee;
                    border-radius: 7px;
                    padding: 20px;
                    margin: 10px 0 20px 0;
                    font-size: 14px;

                    .cookie-detail-item_info {
                      display: flex;
                    }
                  }
                }
              }
            }
          }

          #cookie-detail-body_button {
            display: flex;
            border-bottom: 1px solid #d6d6d6;
            border-top: 1px solid #d6d6d6;

            .cookie-detail-body_button__item {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              align-items: center;
              flex: 1;
              padding: 25px;
              text-align: center;

              strong {
                margin-bottom: 10px;
              }
            }

            .cookie-detail-body_button__item:not(:last-of-type) {
              border-right: 1px solid #d6d6d6;
            }
          }
        }
      }

      #cookie-detail-footer {
        border-top: 1px solid #d6d6d6;

        #cookie-detail-footer-container {
          padding: 10px 20px 20px 20px;
          display: flex;

          button {
            background-color: #5d0749;
            border: 2px solid #ffffff;
            border-radius: .25em;
            color: #ffffff;
            display: block;
            font-weight: 600;
            padding: 15px;
            margin: 0 5px;
            text-align: center;
            user-select: none;
            width: 100%;
            font-size: 16px;
            cursor: pointer;
          }
        }
      }
    }
  }

}

@media (max-width: 500px) {

  #cookie-detail-header {
    padding: 5px 20px !important;
  }
  .cookie-detail-body_content {
    margin: 10px 0 0 0 !important;
  }
  .cookie-detail-body_button__item {
    padding: 0 25px !important;
    flex-direction: row !important;
    align-items: center !important;
    margin-bottom: 5px !important;
    justify-content: space-between !important;
    line-height: 32px !important;

    strong {
      text-align: left;
    }
  }
  #cookie-detail-body_button {
    display: flex;
    flex-direction: column;
    //overflow-y: auto;
    //height: 100px;
    padding: 5px 0;
  }
  #cookie-detail-footer-container {
    flex-direction: column !important;
  }
  #cookie-detail-footer-container button {
    padding: 5px !important;
    font-size: 14px !important;
    margin: 0 !important;
  }

  #cookie-detail-nav {
    height: 40px !important;
  }

  .cookie-detail-nav_item__link {
    padding: .5em !important;
  }

  .cookie-detail-body_button__item strong {
    margin-bottom: 0px !important;
  }

  .cookie-detail-body_content__item {
    padding-bottom: 15px !important;
    margin-bottom: 10px !important;
  }

  .cookie-detail-item_info {
    flex-direction: column;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/Cookie.vue